<template>
  <div>
    <v-card class="px-14 py-9" style="overflow-y: hidden" flat>
      <div class="mb-4">
      <span ><b> Position</b></span>
      </div>
      <div class="d-flex justify-space-between">
        <div>
          <v-card flat class="mb-14 box" width="120" height="75" color="#C1DBEB"> <h1>2</h1></v-card>
          <v-card flat height="75"  class="box mt-14" color="#C1DBEB"> <h1>3</h1></v-card>
        </div>
        <div >
          <div>
            <v-card flat width="210" class="box" color="#C1DBEB" style="height: 180px"
              ><h1 style="font-size:75px">1</h1></v-card
            >
          </div>
        </div>
        <div>
          <div>
            <v-card flat width="120" class="box" height="60" color="#C1DBEB"><h1>4</h1></v-card>
            <v-card flat width="120" height="60" class="my-3 box" color="#C1DBEB"><h1>5</h1></v-card>
            <v-card flat width="120" class="box" height="60" color="#C1DBEB"><h1>6</h1></v-card>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "organizeblog2component",
};
</script>

<style scoped>
.box {
  display: flex;
  justify-content: center;
  align-items: center;
}
h1{
  color: rgba(8, 8, 22, 0.38);
  font-weight: 700;
}
</style>